import React from "react";
import { Alert } from "react-bootstrap";

export function Alerts({ variant, message }) {
  return <Alert variant={variant}>{message}</Alert>;
}
